"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UuidGenerator = void 0;
const tsyringe_1 = require("tsyringe");
const uuid_1 = require("uuid");
let UuidGenerator = class UuidGenerator {
    /**
     * Creates a new uuid v4.
     */
    create() {
        return uuid_1.v4();
    }
    ;
    /**
     * Checks if the provided string is a valid uuid.
     *
     * @param uuid the uuid to check
     */
    validate(uuid) {
        return uuid_1.validate(uuid);
    }
    ;
    /**
     * Parse the uuid to array of bytes
     *
     * @param uuid the uuid to convert
     * @returns ArrayLike collection of 16 values
     */
    parse(uuid) {
        return uuid_1.parse(uuid);
    }
    ;
    /**
     * Stringify an array of bytes to an uuid
     *
     * @param uuid the array of bytes
     * @returns the converted uuid
     */
    stringify(uuid) {
        return uuid_1.stringify(uuid);
    }
    ;
};
UuidGenerator = __decorate([
    tsyringe_1.singleton()
], UuidGenerator);
exports.UuidGenerator = UuidGenerator;
//# sourceMappingURL=UuidGenerator.js.map